import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cart: null,
  items: [],
  summary: {
    subtotal: '0.00',
    totalItems: 0,
    itemCount: 0,
  },
  loading: false,
  error: null,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCart: (state, action) => {
      const { cart, summary } = action.payload;
      state.cart = cart;
      state.items = cart?.items || [];
      state.summary = summary || initialState.summary;
      state.loading = false;
      state.error = null;
    },

    updateItemQuantity: (state, action) => {
      const { itemId, quantity } = action.payload;
      const item = state.items.find(i => i.id === itemId);
      if (item) {
        item.quantity = quantity;
        // Recalculate summary
        let subtotal = 0;
        let totalItems = 0;
        state.items.forEach(item => {
          subtotal += parseFloat(item.price) * item.quantity;
          totalItems += item.quantity;
        });
        state.summary = {
          subtotal: subtotal.toFixed(2),
          totalItems,
          itemCount: state.items.length,
        };
      }
    },

    removeItem: (state, action) => {
      const itemId = action.payload;
      state.items = state.items.filter(i => i.id !== itemId);
      
      // Recalculate summary
      let subtotal = 0;
      let totalItems = 0;
      state.items.forEach(item => {
        subtotal += parseFloat(item.price) * item.quantity;
        totalItems += item.quantity;
      });
      state.summary = {
        subtotal: subtotal.toFixed(2),
        totalItems,
        itemCount: state.items.length,
      };
    },

    clearCart: (state) => {
      state.items = [];
      state.summary = initialState.summary;
    },

    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setCart,
  updateItemQuantity,
  removeItem,
  clearCart,
  setLoading,
  setError,
  clearError,
} = cartSlice.actions;

// Selectors
export const selectCart = (state) => state.cart;
export const selectCartItems = (state) => state.cart.items;
export const selectCartSummary = (state) => state.cart.summary;
export const selectCartItemCount = (state) => state.cart.summary.itemCount;
export const selectCartTotalItems = (state) => state.cart.summary.totalItems;

export default cartSlice.reducer;